import React, { useMemo, useState } from "react";
import { Segmented, DatePicker, Space } from "antd";
import dayjs from "dayjs";

const { RangePicker } = DatePicker;

const GlobalDateFilter = ({ value, onChange, presets }) => {

  const [selectedPreset, setSelectedPreset] = useState("today");
  const [dateRange, setDateRange] = useState(null);

  React.useEffect(() => {
    if (!value) return;

    if (value.preset) {
      setSelectedPreset(value.preset);
      setDateRange(null);
    }

    if (value.startDate && value.endDate) {
      setSelectedPreset(null);
      setDateRange([
        dayjs(value.startDate),
        dayjs(value.endDate),
      ]);
    }
  }, [value]);

  const DEFAULT_PRESETS = [
    { label: "Today", value: "today" },
    { label: "Yesterday", value: "yesterday" },
    { label: "Last Week", value: "weekly" },
    { label: "Last Month", value: "last30" },
  ];

  const finalPresets = useMemo(
    () => (presets?.length ? presets : DEFAULT_PRESETS),
    [presets]
  );

  const disableTodayAndFuture = (current) =>
    current && current >= dayjs().startOf("day");

  const handlePresetChange = (preset) => {
    setSelectedPreset(preset);
    setDateRange(null);

    onChange?.({ preset });
  };

  const handleRangeChange = (dates) => {
    if (!dates) {
      setDateRange(null);
      onChange?.(null);
      return;
    }

    setSelectedPreset(null);
    setDateRange(dates);

    onChange?.({
      startDate: dates[0].format("YYYY-MM-DD"),
      endDate: dates[1].format("YYYY-MM-DD"),
    });
  };

  const styledCss = `

  /* ===== FORCE ROBOTO FOR ALL ANT ELEMENTS IN THIS COMPONENT ===== */
.range-controls,
.range-controls * {
  font-family: "Roboto", "Helvetica", "Arial", sans-serif !important;
}

/* ===== OUTER SEGMENTED CONTAINER ===== */
.range-controls .ant-segmented {
  padding: 0;
  border-radius: 999px;
  border: 1px solid #ef4444;
  background: #ffffff;
  overflow: hidden;
  height: 36px;
}

/* REMOVE ANT DIVIDERS */
.range-controls .ant-segmented-item::after {
  display: none !important;
}

/* BASE ITEM */
.range-controls .ant-segmented-item {
  padding: 0 !important;
  margin: 0;
  background: transparent !important;
}

/* LABEL = CLICK AREA */
.range-controls .ant-segmented-item-label {
  height: 36px;
  line-height: 36px;
  padding: 0 14px;
  font-size: 13px;
  font-weight: 500;
  color: #000;
  background: #ffffff;
  border-right: 1px solid #ef4444;
  transition: all 0.2s ease;
}

/* LAST ITEM NO DIVIDER */
.range-controls .ant-segmented-item:last-child
.ant-segmented-item-label {
  border-right: none;
}

/* HOVER */
.range-controls .ant-segmented-item-label:hover {
  background: #fff1f2;
}

/* SELECTED */
.range-controls .ant-segmented-item-selected {
  background: transparent !important;
}

.range-controls .ant-segmented-item-selected
.ant-segmented-item-label {
  background: #ef4444;
  color: #ffffff;
  font-weight: 600;
}

/* ===== RANGE PICKER MATCH ===== */
.range-controls .ant-picker {
  height: 36px;
  padding: 0 12px;
  border-radius: 999px;
  font-size: 13px;
}
  .range-controls {
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;
}

  .range-controls .range-row {
  display: flex;
  align-items: center;
  gap: 12px;
}

/* Fix AntD picker inner alignment */
.range-controls .ant-picker-input {
  height: 36px;
  display: flex;
  align-items: center;
}

.range-controls .ant-picker-input > input {
  height: 36px;
  line-height: 36px;
  font-size: 13px;
}

`;


  return (
    <div
      className="range-controls"
      style={{ display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap" }}
    >
      <style>{styledCss}</style>
      <div className="range-row">
        <Segmented
          value={selectedPreset}
          options={finalPresets}
          onChange={handlePresetChange}
        />

        <RangePicker
          value={dateRange}
          onChange={handleRangeChange}
          allowClear
          disabledDate={disableTodayAndFuture}
        />
      </div>

    </div>
  );
};

export default GlobalDateFilter;
